import script from "./HealthCalendarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HealthCalendarView.vue?vue&type=script&setup=true&lang=ts"

import "./HealthCalendarView.vue?vue&type=style&index=0&id=09c9b10c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09c9b10c"]])

export default __exports__